import { RefLinkForm } from "./index.js";
import "react";
import { Modal } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
//#region src/modules/shared/RefLinkForm/RefLinkFormModal.tsx
function RefLinkFormModal({ closeHandler, controller, onComplete, refLinkId }) {
	return /* @__PURE__ */ jsx(Modal, {
		closeHandler,
		escPressClose: true,
		header: "Ref Link",
		children: /* @__PURE__ */ jsx(RefLinkForm, {
			controller,
			onComplete: () => {
				closeHandler();
				onComplete?.();
			},
			id: refLinkId
		})
	});
}
//#endregion
export { RefLinkFormModal };

//# sourceMappingURL=RefLinkFormModal.js.map